import { render, staticRenderFns } from "./ProductCenter.vue?vue&type=template&id=04cb8b68"
import script from "./ProductCenter.vue?vue&type=script&lang=js"
export * from "./ProductCenter.vue?vue&type=script&lang=js"
import style0 from "./ProductCenter.vue?vue&type=style&index=0&id=04cb8b68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports